const $sizes = ['sm', 'md', 'lg', 'xl'];
const $displays = [
    'none',
    'inline',
    'inline-block',
    'block',
    'table',
    'table-cell',
    'flex',
    'inline-flex',
];

export function classNames(type, modifiers = {}) {
    let className = type;

    $sizes.map((size) => {
        if (modifiers.hasOwnProperty(size)) {
            className += '-' + size;
        }
    });

    $displays.map((side) => {
        if (modifiers.hasOwnProperty(side)) {
            className += '-' + side;
        }
    });

    return className;
} 


// WEBPACK FOOTER //
// ./src/baseComponents/directives/Display/classNames.js